import { productArt, type ProductArtKey } from "@/components/ProductArt";

export type Category = "elektronik" | "handys" | "computer";

export const categories: { id: Category; label: string; art: ProductArtKey }[] =
  [
    { id: "elektronik", label: "Elektronik", art: "tv" },
    { id: "handys", label: "Handys & Tarife", art: "smartphone" },
    { id: "computer", label: "Computer & Laptops", art: "laptop" },
  ];

export interface Offer {
  retailer: string;
  price: number;
}

export interface Product {
  id: string;
  name: string;
  brand: string;
  category: Category;
  art: ProductArtKey;
  offers: Offer[];
}

export const products: Product[] = [
  {
    id: "escooter-urban",
    name: "E-Scooter 25km/h, klappbar",
    brand: "RollWerk",
    category: "elektronik",
    art: "escooter",
    offers: [
      { retailer: "Shop B", price: 399 },
      { retailer: "Shop A", price: 429 },
      { retailer: "Shop C", price: 459 },
    ],
  },
  {
    id: "tv-oled-55",
    name: '55" 4K OLED TV',
    brand: "LumaVision",
    category: "elektronik",
    art: "tv",
    offers: [
      { retailer: "Shop A", price: 769 },
      { retailer: "Shop B", price: 799 },
      { retailer: "Shop C", price: 849 },
    ],
  },
  {
    id: "kopfhoerer-anc",
    name: "Noise-Cancelling Kopfhörer",
    brand: "SoundPeak",
    category: "elektronik",
    art: "headphones",
    offers: [
      { retailer: "Shop B", price: 249 },
      { retailer: "Shop C", price: 259 },
      { retailer: "Shop A", price: 279 },
    ],
  },
  {
    id: "kamera-systemkamera",
    name: "Spiegellose Systemkamera",
    brand: "PixelPro",
    category: "elektronik",
    art: "camera",
    offers: [
      { retailer: "Shop C", price: 1099 },
      { retailer: "Shop A", price: 1149 },
      { retailer: "Shop B", price: 1199 },
    ],
  },
  {
    id: "smartphone-128gb",
    name: "Smartphone 128GB 5G",
    brand: "NovaPhone",
    category: "handys",
    art: "smartphone",
    offers: [
      { retailer: "Shop A", price: 519 },
      { retailer: "Shop B", price: 549 },
      { retailer: "Shop C", price: 599 },
    ],
  },
  {
    id: "smartwatch-gps",
    name: "Smartwatch GPS",
    brand: "PulseFit",
    category: "handys",
    art: "smartwatch",
    offers: [
      { retailer: "Shop B", price: 229 },
      { retailer: "Shop C", price: 239 },
      { retailer: "Shop A", price: 249 },
    ],
  },
  {
    id: "tablet-11",
    name: "Tablet 11 Zoll",
    brand: "AeroTab",
    category: "handys",
    art: "tablet",
    offers: [
      { retailer: "Shop C", price: 379 },
      { retailer: "Shop A", price: 389 },
      { retailer: "Shop B", price: 399 },
    ],
  },
  {
    id: "ultrabook-14",
    name: 'Ultrabook 14" 16GB RAM',
    brand: "ByteBook",
    category: "computer",
    art: "laptop",
    offers: [
      { retailer: "Shop A", price: 879 },
      { retailer: "Shop B", price: 899 },
      { retailer: "Shop C", price: 949 },
    ],
  },
  {
    id: "gaming-pc",
    name: "Gaming-PC RTX-ready",
    brand: "ForgeTech",
    category: "computer",
    art: "gaming-pc",
    offers: [
      { retailer: "Shop B", price: 1299 },
      { retailer: "Shop C", price: 1349 },
      { retailer: "Shop A", price: 1399 },
    ],
  },
  {
    id: "curved-monitor-27",
    name: '27" Curved Monitor',
    brand: "ViewArc",
    category: "computer",
    art: "monitor",
    offers: [
      { retailer: "Shop C", price: 249 },
      { retailer: "Shop A", price: 259 },
      { retailer: "Shop B", price: 279 },
    ],
  },
];

export function bestOffer(offers: Offer[]): Offer {
  return offers.reduce((best, o) => (o.price < best.price ? o : best));
}

export function worstOffer(offers: Offer[]): Offer {
  return offers.reduce((worst, o) => (o.price > worst.price ? o : worst));
}

export function artFor(key: ProductArtKey) {
  return productArt[key];
}
